import React from "react";
import { Link } from "react-router-dom";
import { getPortalUrl } from "../../config/domains";
import trustBannerBg from "../../images/use-case/trustBannerBg.png";

const TrustBanner = () => {
  return (
    <section className="w-full my-10 sm:my-16">
      <div
        className="w-full overflow-hidden relative shadow-xl"
        data-aos="zoom-in"
      >
        {/* Background Image */}
        <img
          src={trustBannerBg}
          alt="Support agent with headset"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />

        {/* Dark Film Overlay for High Contrast */}
        <div className="absolute inset-0 bg-black/60 sm:bg-black/55 backdrop-blur-[0.5px]"></div>

        {/* Centered Content */}
        <div className="relative z-10 py-20 sm:py-28 lg:py-32 px-6 sm:px-12 text-center flex flex-col items-center justify-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-[48px] font-extrabold text-white font-['Axiforma',sans-serif] tracking-tight leading-tight max-w-4xl">
            Build multilingual experiences your users can trust
          </h2>

          <p className="text-gray-200 text-sm sm:text-base md:text-lg max-w-2xl mx-auto mt-4 mb-8 leading-relaxed font-normal">
            Whether you’re serving patients, customers, students, or communities—NKENNEAi helps you deliver communication that’s accurate, culturally aware, and accessible.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4">
            <a
              href={getPortalUrl("/user-dashboard/developer-tools")}
              className="inline-flex items-center justify-center bg-[#1A5F4C] hover:bg-[#144B3C] text-white text-sm sm:text-base font-medium px-6 sm:px-7 py-3.5 rounded-xl transition-all duration-200 shadow hover:shadow-md hover:-translate-y-0.5"
            >
              Get An API Key
            </a>

            <Link
              to="/contact-us"
              className="inline-flex items-center justify-center bg-white hover:bg-gray-100 text-[#0D3429] text-sm sm:text-base font-medium px-6 sm:px-7 py-3.5 rounded-xl transition-all duration-200 shadow hover:shadow-md hover:-translate-y-0.5"
            >
              Talk To Our Team
            </Link>

            <Link
              to="/playground"
              className="inline-flex items-center justify-center bg-black/40 hover:bg-black/60 text-white border border-white/35 text-sm sm:text-base font-medium px-6 sm:px-7 py-3.5 rounded-xl backdrop-blur-sm transition-all duration-200 hover:-translate-y-0.5"
            >
              Try The Playground
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBanner;
